






























































import emulator from '../emulator/Emulator';
import Vue, {PropType} from 'vue';
import {WasmModule} from '@/emulator/WasmModule';
import {Emulator} from '@/emulator/Emulator';
import EmulatorInfo from '@/emulator/EmulatorInfo';

enum State {
    NotLoaded = 'notLoaded',
    Loading = 'loading',
    Loaded = 'loaded',
    Error = 'error',
}

export default Vue.extend({
    name: 'computer-emulator',

    props: {
        debug: {
            type: Boolean as PropType<boolean>,
            default: () => false,
        },
        rom: {
            type: [Array, Uint8Array] as PropType<FileContent>,
            default: () => [],
        },
        version: {
            type: String as PropType<string>,
            required: true,
        },
    },

    data(): {
        state: State,
        module?: WasmModule,
        emulator?: Emulator,
        error?: string,
    } {
        return {
            state: State.NotLoaded,
        };
    },

    methods: {
        async activate() {
            this.state = State.Loading;
            try {
                const emu = await emulator(this.version, 'canvas');
                this.state = State.Loaded;
                this.emulator = emu;
                this.emulator.init();
                if (this.rom.length > 0) {
                    if (this.rom instanceof Array)
                        this.emulator.loadMemory(this.rom as number[]);
                    else if (this.rom instanceof Uint8Array)
                        this.emulator.loadMemory(Array.from(this.rom as Uint8Array));
                    else
                        throw new Error('Binary is in a format not supported by the emulator');
                }
                if (!this.debug)
                    this.emulator.mainLoop(() => {
                        this.error = 'Execution error (see console)';
                        this.state = State.Error;
                    });
                this.$emit('initialized', emu);
            } catch (e) {
                if (e === 'unwind')
                    return;
                console.error(e);
                this.error = 'Segmentation fault';
                this.state = State.Error;
            }
        },

        debuggerFrame() {
            this.emulator!.frame();
        },

        debuggerStep() {
            this.emulator!.step();
        },

        destroy() {
            if (this.emulator) {
                this.emulator.stopMainLoop();
                try {
                    this.emulator.destroy();
                } catch (e) {
                    if (!(e instanceof TypeError))
                        throw e;
                }
            }
            console.log('Emulator destroyed.');
            this.state = State.Loaded;
        },

        debuggerState(memoryBlock: number) : EmulatorInfo {
            return this.emulator!.debuggerState(memoryBlock);
        },

        demo() {
            // loadBinary(this.module, 'demo.bin');
        },
    },

    mounted() {
        if (this.debug) {
            this.activate();
        }
    },

    beforeDestroy() {
        console.log('beforeDestroy');
        this.destroy();
    },

});
